import React, {useEffect, useRef} from "react";
const rootUrl = process.env.MIX_APP_ROOT

export default function SVGIcon(props) {
    const toolTipRef = useRef(null);
    useEffect(()=>{
        if(toolTipRef.current !== null)
        {
            $(toolTipRef.current).tooltip()
        }
    },[])
    let divProps = { };

    if (props.title) {
        divProps['data-bs-toggle']="tooltip"
        divProps['data-bs-placement']="top"
        divProps['title'] = props.title
    }

    let imgProps = {
        width: 16,
        height: 16
    };
    if (props.width)
        imgProps['width'] = props.width
    if (props.height)
        imgProps['height'] = props.height
    if (props.src)
        imgProps['src'] = rootUrl + props.src
    else
        throw new Error('SVGIcon requires src property')

    return (
        <div className="d-inline-block m-1" {...divProps} ref={toolTipRef}>
            <img {...imgProps} />
        </div>
    );
}
